import React from "react";
import { Button } from "primereact/button";
import { AppCard } from "../../components/ui";
import { FileProcessingScreenProps } from "./types";

const FileProcessingScreen: React.FC<FileProcessingScreenProps> = ({
  uploadProgress,
  isUploadComplete = false,
  onProcessTransactions
}) => {
  return (
    <AppCard>
      <AppCard.Header title={isUploadComplete ? 'File Upload Complete' : 'Processing File'} />
      <AppCard.Body>
        <div className="text-center">
          {isUploadComplete ? (
            <>
              <i className="fas fa-check-circle text-5xl text-success-500 mb-5"></i>
              <div className="text-lg font-bold text-neutral-700 dark:text-neutral-300 mb-5">File uploaded successfully!</div>
              <div className="text-center mt-4">
                <Button
                  onClick={onProcessTransactions}
                  disabled={!onProcessTransactions}
                  icon="fas fa-cogs"
                  label="Process Transactions"
                  size="large"
                />
              </div>
            </>
          ) : (
            <>
              <div className="text-center py-10 px-5">
                <div className="mb-5">
                  <div className="spinner w-[50px] h-[50px] border-4 border-neutral-200 dark:border-neutral-800 border-t-primary-500 rounded-full animate-spin mx-auto"></div>
                </div>
                <div className="text-lg font-semibold text-neutral-700 dark:text-neutral-300 mb-2.5">Processing your file...</div>
                <div className="text-sm text-neutral-500 dark:text-neutral-400 max-w-[300px] mx-auto leading-relaxed">
                  Please wait while we validate and process your payment file
                </div>
              </div>
            </>
          )}
        </div>
      </AppCard.Body>
    </AppCard>
  );
};

export default FileProcessingScreen;
